import store from '@/store';
import moment from 'moment';

export default {
  install(Vue, options) {
    Vue.prototype.$checkAfterMeeting = function(meetingType, startDate, endDate) {
      meetingType = 'COMM_ST';
      const meetingCodeObj = store.getters.breadcrumbList.filter(x => ['stlifecycle', 'splifecycle', 'mdlifecycle'].some(v => x.name === v));
      let meetingCode = '';
      if (meetingCodeObj.length > 0) {
        if (meetingCodeObj[0].title.includes('~')) {
          const meetingCodeArr = meetingCodeObj[0].title.split('-');
          meetingCodeArr.pop();
          meetingCode = meetingCodeArr.join('-');
        } else {
          meetingCode = meetingCodeObj[0].title;
        }
      }
      if (store.getters.unlockMeetingMap[meetingCode] && store.getters.unlockMeetingMap[meetingCode].meetingLock === '1') {
        return moment().isAfter(moment(endDate).add(5000, 'days'), 'days');
      }
      const check = store.getters.afterMeetingDays.filter(x => x.meetingType.toLowerCase() === meetingType.toLowerCase());
      return moment().isAfter(moment(endDate).add(check[0].days * 1, 'days'), 'days');
    };
  }
};



// WEBPACK FOOTER //
// ./src/libs/afterMeeting/index.js